import { ReactComponent as HoFPlaceholder } from '../../../../assets/icons/hof-placeholder.svg'
import { ReactComponent as HoFBadge } from '../../../../assets/icons/hof-badge.svg'
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from "react-i18next";

const countLocationScenes = (locationObjectives) => {
    let count = 0;
    {
        Object.keys(locationObjectives).map((objective) => {
            let scenes = locationObjectives[objective];

            return (
                scenes.map(() => {
                    count++;
                })
            )
        })
    }

    return count;
}

const BadgeSection = (objectives) => {
    const { t: translate } = useTranslation();
    const letters = ['A', 'B', 'C', 'D', 'E'];
    let locationObjectives = objectives.objectives

    if (Object.keys(locationObjectives).length === 0) {
        return null
    }

    let sectionCount = countLocationScenes(locationObjectives);
    const [isCollapsed, setIsCollapsed] = useState(true);
    const [sectionHeight, setSectionHeight] = useState(true);
    const sectionRef = useRef();
    let buttonCount = sectionCount - 8
    let buttonText = isCollapsed ? translate('view-more-hofs', { buttonCount }) : translate('collapse-hofs')

    const calcMaxHeight = () => {
        let height = sectionRef.current.offsetHeight;
        setSectionHeight(`${height}px`)
    }

    useEffect(() => {
        if (isCollapsed) {
            if(window.innerWidth < 768) {
                setSectionHeight('158px');
            } else if(window.innerWidth < 1024 && window.innerWidth > 768) {
                setSectionHeight('78px');
            } else {
                setSectionHeight('78px');
            }
            
        } else {
            calcMaxHeight();
        }
    }, [isCollapsed])


    return (
        <div className={`location-hof-section ${sectionCount > 8 ? 'location-hof-section--collapsable' : ''}`} >
            <div className='badges-container' style={{ maxHeight: sectionHeight }}>
                <div className='badges' ref={sectionRef}>
                    {Object.keys(locationObjectives).map((objective) => {
                        let scenes = locationObjectives[objective];

                        return (
                            scenes.map((scene, index) => {
                                let badge = scene.halloffame ? 
                                <span key={index} className='hof-badge hof-badge--completed'>
                                    <HoFBadge />
                                    <span className='hof-badge__label'>
                                        <span>{objective}</span>
                                        {`Scene ${letters[index]}`}
                                    </span>
                                </span> 
                                : 
                                <span key={index} className='hof-badge'>
                                    <HoFPlaceholder />
                                    <span className='hof-badge__label'>
                                        <span>{objective}</span>
                                        {`Scene ${letters[index]}`}
                                    </span>
                                </span>
                                return (badge)
                            })
                        )
                    })}
                </div>
            </div>
            {sectionCount > 8 && <span onClick={() => { setIsCollapsed(!isCollapsed) }} className='location-hof-section__button'>{buttonText}</span>}
        </div>
    )
}

export default BadgeSection